// extracted by mini-css-extract-plugin
export var container = "_ew-1";
export var editor = "_ew-2";
export var resizable = "_ew-3";
export var wrapper = "_ew-0";